module.exports = __webpack_public_path__ + "static/media/krx-derivatives-seeds-04.037dd93d.jpg";